export const valueCompassHelperTextContent = `
  <p><strong>Select the appropriate Value Compass point for this project.</strong></p>
  <p>You may select one or more points in the Value Compass for this 
  project by holding the Ctrl key in your keyboard while clicking on the appropriate values.
</p>
`;

export const focusAreaHelperTextContent = `
  <p><strong>Select the appropriate focus area for this project.</strong></p>
  <p>If you can't find any applicable value, request a new focus area to be added through the Contact Us Form.
Get credit for the work you do by correctly classifying your project!
</p>
`;

export const smartGoalHelperTextContent = `
  <p><strong>(SMART - Specific, Measurable, Attainable, Realistic, Time-bound)</strong><br />
Example: "We will improve <strong>[SOMETHING]</strong> from <strong>[X]</strong> to <strong>[Z]</strong> by <strong>[DATE]</strong>"
</p>
`;

export const performanceMetricHelperTextContent = `
   <p>Select the appropriate metric for this project.
If you can't find any applicable value, request a new metric to be added through the Contact Us Form.
Get credit for the work you do by correctly classifying your project!
</p>
`;

export const goalSettingHelperTextContent = `
   <p>These are numeric fields. Do not enter fractions or percentage sign</p>
   <p>
    <ul class="list-disc pl-6! mt-2">
      <li>Baseline - Value collected before the team executes tests of change. Use baseline for comparison</li>
      <li>Threshold - Minimum accepted criteria or value for project improvement</li>
      <li>Target - Desired goal or criteria for project success</li>
      <li>Stretch - Value or criteria above target. Incentive or challenge to the UBT</li>
    </ul>
  </p>
`;

export const linkToMetricsInformation = `
   <p>Click here to obtain additional information about your project metric.
  </p>
`;

export const toolUsingHelperText = `
   <p>You may use one or more performance improvement tools on this project.
Choose One or More tools by holding the Ctrl key in your keyboard while clicking on the appropriate tools.
Check out the UBT Tracker User Guide or contact your UBT Consultant if you need more information on how/when to use these PI Tools.
  </p>
`;

export const ideaHelperText = `
   <p>Check out these websites for helpful information from similar types of projects.
If you can't find valuable project information, report it through the Contact Us Form.
Don't forget to let us know which project content you need!
  </p>
`;

export const toolAndTipsHelperText = `
   <p>Click here for tools and tips related to this type of project.
If you can't find valuable information, report it through the Contact Us Form.
Don't forget to let us know which content you need!
  </p>
`;


export const testOfChangeHelperText = `
   <p>Tests of Changes (TOCs) are the ideas your team will execute to reach your project goal
  </p>
`;

export const teamDocumentationHelperText = `
   <p>Suggested text: If you have stored project documentation on a web accessible server, copy and paste that url here.
  </p>
`;

export const annualROIHelperText = `
   <p>Annual Return on Investment (ROI).
This is a numeric field. Do not enter any other characters such as "%" or "$".
Enter how much money this project was able to save or generate in a year.
Example : If your monthly ROI = 10000; then enter Annual ROI = 120000 (that is 12 × 10000)
  </p>
`;

export const resultSummaryHelperText = `
  <p>When you're ready to close this project, select the appropriate final result
  </p>
`;


export const resultDescHelperText = `
   <p>Enter a brief summary of your project results.
How well did your team do when comparing your results to the project SMART goal?
  </p>
`;

export const learningPracticeHelperText = `
   <p>Which Tests of Changes worked and which didn't? Why?
Review details on the Test of Change tab (What you did and what TOC results you got).
This is where you can record helpful practices that you want to other teams to know.
  </p>
`;

export const numeratoreHelperText = `
  <p>Do not enter a number here! Enter the <strong>name of your specific measurement.</strong>
Ask yourself: How many of the total (the bottom number) are being considered?
Example: If you're trying to track and improve the percentage of cash collection, 
enter "Amount of Cash Collected" as
 Numerator; "Total Owed" as Denominator; and "Percentage of Cash Collection by 
 Total Owed" as the Calculated Value.
  </p>
`;

export const calculatedValueLabelHelperText = `
  <p>Do not enter a number here! Enter the <strong>name or label of your project metric</strong> based on your project target (Numerator/Denominator)
Example: If you're trying to track and reduce patient falls, enter "Patient Falls" as Numerator; "Total Number of Patients (Weekly)" 
as Denominator; and "Weekly Patient Falls (%)"
  </p>
`;


export const denominatorHelperText = `
   <p>Do not enter a number here! Enter the <strong>name of measurement for the whole population.</strong>
Ask yourself: What is the total number of items being considered?
Example: If you're trying to track and reduce sick calls, enter "Number of Sick Calls" as Numerator; "Number of Days" as Denominator; 
and "Rate of Daily Sick Calls" as the Calculated Value.
  </p>
`;


export const additionalVarialbeLabelHelperText = `
   <p>Track another aspect of the Test of Change that may be important to your project.
It allows them to group their data into one or more categories and display it in a bar chart through the Test Data Chart Page.
Check out the UBT Tracker User Guide or Help Icon with examples of completed forms (Upper right hand side of the 
Project Details, Test of Change, Test Data Tabs)"
  </p>
`;


export const testOfChangeHelperTextContent = `
  <p><strong>One line description of the Test of Change</strong></p>
`;

export const testOfChangeDescHelperTextContent = `
  <p><strong>Brief description of the Test of Change.</strong></p>
`;

export const testOfChangeOutComeHelperTextContent = `
  <p><strong>Brief description of the results of tests, including reasons why it succeeded or failed.</strong></p>
`;

export const testOfRatingHelperTextContent = `
  <p><strong>Did team decide to Adopt, Adapt and
test again, or Abandon the change entirely.</strong></p>
`;

export default {
  valueCompassHelperTextContent,
  focusAreaHelperTextContent,
  smartGoalHelperTextContent,
  goalSettingHelperTextContent,
  linkToMetricsInformation,
  toolUsingHelperText,
  ideaHelperText,
  toolAndTipsHelperText,
  testOfChangeHelperText,
  resultSummaryHelperText,
  resultDescHelperText,
  learningPracticeHelperText,
  numeratoreHelperText,
  calculatedValueLabelHelperText,
  denominatorHelperText,
  additionalVarialbeLabelHelperText,
  testOfChangeHelperTextContent,
  testOfChangeDescHelperTextContent,
  testOfChangeOutComeHelperTextContent,
  testOfRatingHelperTextContent,
};
